import LegalLayout, { Section, Bullets } from "@/components/LegalLayout";
import { LEGAL_VERSIONS, PROHIBITED_INFORMATION } from "@/constants/legalContent";

export default function AcceptableUse() {
  return (
    <LegalLayout
      title="Acceptable Use Policy"
      intro="FindRxStaff works only if pharmacies and pharmacy professionals can trust what they see. This policy explains what is not allowed on the platform. We may update it from time to time."
    >
      <p className="text-sm text-slate-500" data-testid="aup-version">
        Acceptable Use Policy version {LEGAL_VERSIONS.acceptable_use}
      </p>

      <Section heading="Prohibited conduct">
        <p>Users must not:</p>
        <Bullets
          items={[
            "Upload patient information or Protected Health Information (PHI)",
            "Upload malicious files or code",
            "Impersonate another person or organization",
            "Create fake professional credentials",
            "Misrepresent a license, registration or certification",
            "Post fraudulent shifts",
            "Post intentionally misleading compensation",
            "Harass, threaten or abuse other users",
            "Discriminate unlawfully",
            "Spam users",
            "Scrape the platform or harvest user data",
            "Abuse messaging or notification features",
            "Attempt unauthorized access or circumvent security controls",
            "Use the platform for illegal activities",
            "Post confidential pharmacy business information",
            "Post information they do not have permission to disclose",
          ]}
        />
      </Section>

      <Section heading="Information that must never be posted">
        <Bullets items={PROHIBITED_INFORMATION} />
      </Section>

      <Section heading="Reporting a problem">
        <p>
          Every worker profile, pharmacy profile and shift has a Report action. Choose the closest category —
          for example fake account, incorrect license or credential, fraud, spam, harassment, inappropriate
          content, confidential information, patient information / PHI, or incorrect shift information — and
          add a short factual description. Do not include patient information in a report.
        </p>
        <p>
          You can also block a user, which stops further matching and contact between your accounts where
          practical. Blocked users can be managed in Settings.
        </p>
      </Section>

      <Section heading="Enforcement">
        <p>
          We review reports and may remove content, cancel shifts, limit features, suspend accounts or
          terminate accounts. Key administrative actions are recorded in an internal audit trail. Where
          conduct may be unlawful, we may take further steps consistent with applicable law.
        </p>
      </Section>
    </LegalLayout>
  );
}
